/**
 * 客户回款，银行登记单 新增页面 表单配置处理
 * @author zjs
 * @time 2017-10-25
 */
export default {
    data () {
        return {
            // 表单组件配置
            formConfig: [{
                name: "创建日期",
                type: "LyDatePicker",
                field: "work_time",
                json: {
                    type: 'date'
                },
                default: ""
            },{
                name: "业务日期",
                type: "LyDatePicker",
                field: "trade_time",
                json: {
                    type: 'date',
                },
                default: ""
            },{
                name: '制单人',
                type: 'LySelect',
                field: "zhidanren_id",
                json: {
                    all: false,
                    api: 'api/clerk'
                }
            },{
                name: "收款账户",
                type: "LySelect",
                field: "account_id",
                json: {
                    all: false,
                    api: 'api/shoukuanzh?tag_type=cash',
                }
            },{
                name: "收支类型",
                type: "LySelect",
                field: "payment_type",
                json: {
                    all: false,
                    data: [{
                        value: '1',
                        label: '收入'
                    }, {
                        value: '2',
                        label: '支出'
                    }]
                },
                default: "1"
            },{
                name: "收支金额",
                type: "LyInputNumber",
                field: "amount",
                width: '220px',
                json: {
                    min: 0
                },
                default: ""
            },{
                name: "摘要",
                placeholder: "请输入摘要",
                type: "ElInput",
                field: "zhaiyao",
                width: '1005px',
                json: {
                    span: 24
                },
                default: ""
            }]
        }
    }
}